<template>
    <div>
        <div class="nodata">
            <img src="../assets/img/none.png" alt="">
            <span>暂无记录</span>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>
<style scoped>
    .nodata {
        text-align: center;
        font-size: 12px;
        color: #B1B1B1;
        margin-top: 100px;
    }

    .nodata img {
        width: 80px;
        height: 80px;
        margin: 0 auto 15px;
        display: block;
    }
</style>